import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import VmsPageCard from "../components/VmsPageCard";
import { vmsApi } from "../services/vmsApi";

const VmsSetupAdmin = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    setup_key: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const onChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await vmsApi.setupAdmin(form);
      toast({
        title: "Admin setup complete",
        status: "success",
        duration: 2500,
        isClosable: true,
      });
      navigate("/vms/login");
    } catch (err) {
      toast({
        title: "Setup failed",
        description: err?.message || "Could not create admin user.",
        status: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box minH="100vh" bg="gray.50" p={6}>
      <Box maxW="760px" mx="auto">
        <VmsPageCard
          title="VMS Admin Setup"
          description="Bootstrap admin accounts. Provide the backend setup key to authorize this action."
        >
          <Box as="form" onSubmit={handleSubmit}>
            <VStack spacing={4} align="stretch">
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                <FormControl isRequired>
                  <FormLabel>Setup Key</FormLabel>
                  <Input
                    type="password"
                    value={form.setup_key}
                    onChange={(e) => onChange("setup_key", e.target.value)}
                    borderRadius="12px"
                  />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Name</FormLabel>
                  <Input
                    value={form.name}
                    onChange={(e) => onChange("name", e.target.value)}
                    borderRadius="12px"
                  />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Email</FormLabel>
                  <Input
                    type="email"
                    value={form.email}
                    onChange={(e) => onChange("email", e.target.value)}
                    borderRadius="12px"
                  />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Password</FormLabel>
                  <Input
                    type="password"
                    value={form.password}
                    onChange={(e) => onChange("password", e.target.value)}
                    borderRadius="12px"
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Phone</FormLabel>
                  <Input
                    value={form.phone}
                    onChange={(e) => onChange("phone", e.target.value)}
                    borderRadius="12px"
                  />
                </FormControl>
              </SimpleGrid>
              <Button type="submit" colorScheme="green" isLoading={isLoading} borderRadius="12px" h="50px">
                Create Admin
              </Button>
            </VStack>
          </Box>
        </VmsPageCard>
      </Box>
    </Box>
  );
};

export default VmsSetupAdmin;
